import moment from "moment";
import { getMaxStayForDate } from "../../../../../utils/getMaxStayForDate";
import { getMinStayForDate } from "../../../../../utils/getMinStayForDate";

function filterByCondition({
  dates,
  duplicaterooms,
  ratePlans,
  setFromdate,
  setTodate,
  setRooms,
  adultsFilter,
  childrenFilter,
}) {
  if (
    dates &&
    Array.isArray(dates) &&
    dates.length === 2 &&
    dates.every((d) => d !== null && d !== undefined)
  ) {
    const fromDateFormatted = dates[0].format("DD-MM-YYYY");
    const toDateFormatted = dates[1].format("DD-MM-YYYY");
    setFromdate(fromDateFormatted);
    setTodate(toDateFormatted);

    const temprooms = duplicaterooms
      .filter((room) => {
        if (adultsFilter || childrenFilter) {
          // Occupancy check
          if (room.maxadult < adultsFilter || room.maxchild < childrenFilter)
            return false;
        }
        let availability = true;

        // Optimized: Check closeout for the entire range before main loop
        let closeoutExists = false;
        if (room.closeout && Object.keys(room.closeout).length > 0) {
          let startDate = moment(fromDateFormatted, "DD-MM-YYYY");
          const endDate = moment(toDateFormatted, "DD-MM-YYYY").subtract(
            1,
            "days"
          );
          while (startDate.isSameOrBefore(endDate)) {
            const dateStr = startDate.format("DD-MM-YYYY");
            if (room.closeout[dateStr]?.all) {
              closeoutExists = true;
              break;
            }
            startDate = startDate.add(1, "days");
          }
        }
        if (closeoutExists) {
          availability = false;
        }

        // Main loop for availability and bookings
        for (
          let d = moment(fromDateFormatted, "DD-MM-YYYY");
          d.isBefore(moment(toDateFormatted, "DD-MM-YYYY"));
          d.add(1, "days")
        ) {
          const dateStr = d.format("DD-MM-YYYY");

          if (room.availability && room.availability[dateStr] === 0) {
            availability = false;
            break;
          }

          if (room.currentbookings && room.currentbookings.length > 0) {
            let bookedRoomsCount = 0;

            for (const booking of room.currentbookings) {
              const bookingFromDate = moment(booking.fromdate, "DD-MM-YYYY");
              const bookingToDate = moment(booking.todate, "DD-MM-YYYY");

              if (
                moment(dateStr, "DD-MM-YYYY").isBetween(
                  bookingFromDate,
                  bookingToDate,
                  null,
                  "[]"
                )
              ) {
                bookedRoomsCount += booking.roomCount || 1;
              }
            }

            if (bookedRoomsCount >= room.maxcount) {
              availability = false;
              break;
            }
          }
        }
        return availability;
      })
      .sort((a, b) => (a.order || 0) - (b.order || 0))
      .map((room) => {
        const roomWithDiscountedRatePlans = { ...room };

        // Filter out rate plans that are closed for any date in the selected range
        roomWithDiscountedRatePlans.ratePlans = (
          ratePlans[room._id] || []
        ).filter((ratePlan) => {
          let isClosed = false;
          let availability = true;
          let startDate = moment(fromDateFormatted, "DD-MM-YYYY");
          const endDate = moment(toDateFormatted, "DD-MM-YYYY").subtract(
            1,
            "days"
          );
          const checkInDate = moment(fromDateFormatted, "DD-MM-YYYY");
          const checkOutDate = moment(toDateFormatted, "DD-MM-YYYY");
          const durationDays = checkOutDate.diff(checkInDate, "days");
          while (startDate.isSameOrBefore(endDate)) {
            const dateStr = startDate.format("DD-MM-YYYY");
            if (
              room.closeout &&
              room.closeout[dateStr] &&
              (room.closeout[dateStr].all === true ||
                (Array.isArray(room.closeout[dateStr].ratePlans) &&
                  room.closeout[dateStr].ratePlans.includes(ratePlan._id)))
            ) {
              isClosed = true;
              break;
            }
            let maxMinStay = 0;
            let minMaxStay = Infinity;

            //Get min stay from room object for the date
            const minStayArray = room.minimumStay?.[dateStr] || [];
            const minStayForDate = getMinStayForDate({
              minimumStays: minStayArray,
              selectedRatePlanId: ratePlan._id,
            });
            maxMinStay = Math.max(maxMinStay, minStayForDate);

            //Get max stay from room object for the date
            const maxStayArray = room.maximumStay?.[dateStr] || [];
            const maxStayForDate = getMaxStayForDate({
              maximumStays: maxStayArray,
              selectedRatePlanId: ratePlan._id,
            });
            minMaxStay = Math.min(minMaxStay, maxStayForDate);
            if (
              durationDays < maxMinStay ||
              (minMaxStay && durationDays > minMaxStay)
            ) {
              console.log(
                `Room ${room._id} is not available for ${ratePlan._id} from ${fromDateFormatted} to ${toDateFormatted}, ${durationDays} days stay does not meet min/max stay requirements.${minStayForDate}-${maxStayForDate}`
              );
              availability = false;
              break;
            }
            startDate = startDate.add(1, "days");
          }
          if (isClosed) return false;
          return availability;
        });

        return roomWithDiscountedRatePlans;
      })
      .filter((room) => room.ratePlans && room.ratePlans.length > 0);
    setRooms(temprooms);
  }
}

export { filterByCondition };
